<template>
  <div>
    <DataNavigation></DataNavigation>
    <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
    <div class="index_content">
      <Layout>
        <Sider width="208">
          <div class="right_column">
            <p class="top-tip">金融机构</p>
            <div class="keyword-input">
              <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
            </div>
            <div class="rigit_title">
              <span>筛选</span>
              <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
                <a href="javascript:void(0)">
                  <span>{{screen_active}}</span>
                  <Icon type="md-arrow-dropup" v-if="drop_val" />
                  <Icon type="md-arrow-dropdown" v-else />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="rigit_content">
              <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '投资领域'">
                  <div class="screen_tle" @click="screenTle.tag_arr = !screenTle.tag_arr">
                    <span>投资领域</span>
                    <Icon type="md-add" v-if="!screenTle.tag_arr" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.tag_arr">
                    <ul class="scr_attention">
                      <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                        <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                          <div class="scr_att_tle">
                            <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                            <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                            <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                          </div>
                          <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                            <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                              <span>{{item.name}}<template v-if="tagNum.length">({{item.id | dealName(tagNum, 'id', 'num', '0')}})</template></span>
                            </Checkbox>
                          </div>
                        </li>
                      </CheckboxGroup>
                    </ul>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '投资阶段'">
                  <div class="screen_tle" @click="screenTle.org_stage = !screenTle.org_stage">
                    <span>投资阶段</span>
                    <Icon type="md-add" v-if="!screenTle.org_stage" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.org_stage">
                    <Checkbox v-model="checkAll.org_stage" class="all_option" :disabled="checkAll.org_stage" @on-change="handleCheckAll('org_stage')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.org_stage" @on-change="handleChangeOption($event, 'org_stage')">
                      <Checkbox v-for="(item,index) in org_stage" :label="item.id" :key="index">
                        <span>{{item.name}} <template v-if="orgStageNum.length">({{item.id | dealName(orgStageNum, 'id', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '机构类型'">
                  <div class="screen_tle" @click="screenTle.org_type = !screenTle.org_type">
                    <span>机构类型</span>
                    <Icon type="md-add" v-if="!screenTle.org_type" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.org_type">
                    <Checkbox v-model="checkAll.org_type" class="all_option" :disabled="checkAll.org_type" @on-change="handleCheckAll('org_type')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.org_type" @on-change="handleChangeOption($event, 'org_type')">
                      <Checkbox v-for="(item,index) in org_type" :label="item.id" :key="index">
                        <span>{{item.name}} <template v-if="typeNum.length">({{item.id | dealName(typeNum, 'org_type_id', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '资本来源'">
                  <div class="screen_tle" @click="screenTle.fund_src = !screenTle.fund_src">
                    <span>资本来源</span>
                    <Icon type="md-add" v-if="!screenTle.fund_src" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.fund_src">
                    <Checkbox v-model="checkAll.fund_src" class="all_option" :disabled="checkAll.fund_src" @on-change="handleCheckAll('fund_src')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.fund_src" @on-change="handleChangeOption($event, 'fund_src')">
                      <Checkbox v-for="(item,index) in fund_src" :label="item.id" :key="index">
                        <span>{{item.name}} <template v-if="fundSrcNum.length">({{item.id | dealName(fundSrcNum, 'fund_src_id', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地区选择'">
                  <div class="screen_tle" @click="screenTle.address = !screenTle.address">
                    <span>地区选择</span>
                    <Icon type="md-add" v-if="!screenTle.address" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.address">
                    <RadioGroup v-model="params.demostic" vertical @on-change="handleChangeDemostic">
                      <Radio :label="null"><span>不限</span></Radio>
                      <Radio :label="0"><span>国外({{foreignNum}})</span></Radio>
                      <div class="sec_options" v-if="params.demostic == 0">
                        <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                          <Checkbox v-for="(item,index) in foreign_country" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                      <Radio :label="1" class="bro"><span>国内({{chinaNum}})</span></Radio>
                      <div class="sec_options" v-if="params.demostic == 1">
                        <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                          <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                    </RadioGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '投资时间'">
                  <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                    <span>投资时间</span>
                    <Icon type="md-add" v-if="!screenTle.time" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.time">
                    <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                      <Radio label=""><span>不限</span></Radio>
                      <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                        <span>{{item}}({{item | dealName(yearNum, 'year', 'num', '0')}})</span>
                      </Radio>
                      <Radio label="zdy"><span>自定义</span></Radio>
                    </RadioGroup>
                    <div class="zdy_time" v-if="selTime == 'zdy'">
                      <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                      <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sider>
        <Content>
          <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span>
            <Dropdown @on-click="haddleChangeSort">
              <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
            <div class="sel_tle">已选条件</div>
            <div class="sel_cnt">
              <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
                <Icon type="md-close" />
              </span>
            </div>
            <div class="sel_clear">
              <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
            </div>
          </div>
          <div class="list_div">
            <Table :columns="listColumns" :data="listData" :row-class-name="rowClassName">
              <template slot-scope="{ row }" slot="company_name">
                <div class="company">
                  <div class="logo_img" @click="goEntityDetail(row.uid, 1)">
                    <img :src="row.logo_path | logo_show">
                  </div>
                  <div class="company_name">
                    <p><a @click="goEntityDetail(row.uid, 1)">{{row.short_name}}</a></p>
                  </div>
                </div>
                <div class="supply-demand-list" v-if="row.entity_links.length">
                  <div v-for="(demand, dindex) in row.entity_links" :key="dindex" :class="['demand-item', demand.type == 1 && 'green']" @click="goLinkDetail(demand.id)">
                    <i class="iconfont-pc30">&#xe6de;</i>
                    <div class="tag">{{demand.type == 1 ? '需求' : '供给'}}已验证</div>
                    <div class="link-title">{{demand.title}}</div>
                  </div>
                </div>
              </template>
            </Table>
            <SearchPrompt v-if="haveOption && haveOption.length > 0 && !isVIP  && listData.length == 5 && total > 5"></SearchPrompt>
            <template v-else>
              <div class="page clear" v-if="total > 10">
                <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
              </div>
            </template>
            <Spin fix v-if="listLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import { orgList, orgNum, tagOrgNum } from '../../service'
import { idxOf, remove, removeArrObj } from 'js/findIndex'
import { listMixins } from 'js/listMixins'
import { userInfo } from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import EntityAttention from './components/EntityAttention.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    VipPrompt,
    EntityAttention,
    SearchPrompt,
  },
  data() {
    return {
      listName: '机构',
      listColumns: [
        {
          title: '机构名称',
          width: 190,
          slot: 'company_name',
        },
        {
          title: '简要介绍',
          width: 280,
          render: (h, params) => {
            return h(
              'div',
              {
                class: {
                  'dec-clamp': true,
                },
              },
              filter.empty(params.row.description)
            )
          },
        },
        {
          title: '地区',
          width: 140,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          },
        },
        {
          title: '累计投资',
          width: 100,
          render: (h, params) => {
            return h('span', filter.empty(params.row.tz_event_count))
          },
        },
        {
          title: '近期投资',
          width: 100,
          render: (h, params) => {
            return h(
              'a',
              {
                on: {
                  click: () => {
                    this.goEntityDetail(
                      params.row.latest_event.comp_uid,
                      params.row.latest_event.comp_type
                    )
                  },
                },
              },
              params.row.latest_event.short_name
            )
          },
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h(
                EntityAttention,
                {
                  props: {
                    entityItem: params.row,
                    entityType: '1',
                  },
                },
                [
                  h(
                    'span',
                    {
                      class: {
                        'li-att': true,
                      },
                      slot: 'slot1',
                    },
                    '关注'
                  ),
                  h(
                    'span',
                    {
                      class: {
                        'li-att on': true,
                      },
                      slot: 'slot2',
                    },
                    '已关注'
                  ),
                ]
              ),
            ])
          },
        },
      ],
      params: {
        org_stage: [],
        org_type: [],
        fund_src: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        page: 1,
        user_key: '',
        tag_arr: [],
        keyword: '',
        sort_type: 0,
      },
      screen_dropdown: [
        '全部',
        '投资领域',
        '投资阶段',
        '机构类型',
        '资本来源',
        '地区选择',
        '投资时间',
      ],
      //筛选条件是否展开
      screenTle: {
        tag_arr: false,
        org_stage: false,
        org_type: false,
        fund_src: false,
        address: false,
        time: false,
      },
      //不限
      checkAll: {
        address_id: true,
        org_stage: true,
        org_type: true,
        fund_src: true,
      },
      showAllTag: false,
      chinaNum: 0,
      foreignNum: 0,
      provinceNum: [],
      fundSrcNum: [],
      orgStageNum: [],
      typeNum: [],
      yearNum: [],
      tagNum: [],
      sort_id: 0,
      sort_list: [
        { id: 0, name: '默认排序' },
        { id: 4, name: '最新投资时间倒序' },
        { id: 3, name: '最新投资时间正序' },
        { id: 2, name: '成立时间倒序' },
        { id: 1, name: '成立时间正序' },
      ],
      position_id: '11',
    }
  },
  computed: {
    fund_src() {
      return this.$store.state.org_fund_src
    },
    org_stage() {
      return this.$store.state.org_stage
    },
    org_type() {
      return this.$store.state.org_type
    },
    haveOption() {
      console.log(this.params)
      let optionFundSrc = [],
        optionTag = [],
        optionOrgStage = [],
        optionOrgType = [],
        optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionAddressId = [],
        optionKeyWord = [],
        optionDemostic = []
      this.params.tag_arr.map((a) => {
        optionTag.push({
          type: 'tag_arr',
          name: this.hot_tag_map.length ? filter.dealName(a, this.hot_tag_map) : '--',
          value: a,
        })
      })
      this.params.fund_src.map((a) => {
        optionFundSrc.push({
          type: 'fund_src',
          name: filter.deal(a, 'org_fund_src'),
          value: a,
        })
      })
      this.params.org_stage.map((a) => {
        optionOrgStage.push({
          type: 'org_stage',
          name: filter.deal(a, 'org_stage'),
          value: a,
        })
      })
      this.params.org_type.map((a) => {
        optionOrgType.push({
          type: 'org_type',
          name: filter.deal(a, 'org_type'),
          value: a,
        })
      })
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year,
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time,
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time,
        }
      }
      if (this.params.demostic !== null) {
        optionDemostic = {
          type: 'demostic',
          name: this.params.demostic == 0 ? '国外' : '国内',
          value: this.params.demostic,
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword,
        }
      }
      this.params.address_id.map((a) => {
        optionAddressId.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          value: a,
        })
      })

      return [].concat(
        optionTag,
        optionFundSrc,
        optionOrgStage,
        optionOrgType,
        optionYear,
        optionStart,
        opitonEnd,
        optionKeyWord,
        optionDemostic,
        optionAddressId
      )
    },
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if (this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if (this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await orgList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        tag_arr: [],
        org_stage: [],
        org_type: [],
        fund_src: [],
        round_id: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        page: 1,
        user_key: '',
        keyword: '',
      }
      this.checkAll = {
        org_stage: true,
        org_type: true,
        fund_src: true,
        address_id: true,
      }
      this.search_ipt = ''
      this.selTime = ''
      this.params.page = 1
      this.getEntityList()
    },
    /**
     * 筛选个数
     */
    async getCount() {
      let res = await orgNum((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'chinaNum', res.china)
        this.$set(this.$data, 'foreignNum', res.foreign)
        this.$set(this.$data, 'provinceNum', res.province)
        this.$set(this.$data, 'yearNum', res.year)
        this.$set(this.$data, 'fundSrcNum', res.fund_src)
        this.$set(this.$data, 'orgStageNum', res.org_stage)
        this.$set(this.$data, 'typeNum', res.type)
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 产业领域数量计算-公司
     */
    async getTagNum(t_arr) {
      let res = await tagOrgNum(
        {
          tag_arr: t_arr,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'tagNum', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
  },
  created() {
    if (this.$store.state.org_params != '') {
      this.params = { ...this.$store.state.org_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    if (this.$route.query.keyword) {
      this.params.keyword = this.$route.query.keyword
      this.search_ipt = this.$route.query.keyword
      this.$router.replace({ name: 'OrgList' })
    }
    this.getMeta()
    this.getEntityList()
    this.getCount()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateOrgParams', this.params)
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
